var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDestinationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.99459e-08C7.38382 -0.000162654 6.27854 0.220523 5.24728 0.649453C4.21602 1.07838 3.27898 1.70716 2.48967 2.49987C1.70035 3.29258 1.07423 4.2337 0.647048 5.26949C0.219868 6.30527 -1.17596e-08 7.41544 0 8.53658C0 13.7993 5.37264 20.4511 7.57475 22.9555C7.69052 23.0873 7.83289 23.1929 7.99242 23.2653C8.15195 23.3376 8.32497 23.375 8.5 23.375C8.67503 23.375 8.84805 23.3376 9.00758 23.2653C9.16711 23.1929 9.30948 23.0873 9.42525 22.9555C11.6274 20.4511 17 13.7993 17 8.53658C17 7.41544 16.7801 6.30527 16.353 5.26949C15.9258 4.2337 15.2996 3.29258 14.5103 2.49987C13.721 1.70716 12.784 1.07838 11.7527 0.649453C10.7215 0.220523 9.61618 -0.000162654 8.5 8.99459e-08ZM8.5 11.8129C7.86312 11.8132 7.24046 11.62 6.71079 11.2647C6.18112 10.9095 5.76823 10.4045 5.52434 9.81354C5.28044 9.22258 5.2165 8.57225 5.3406 7.94479C5.4647 7.31734 5.77127 6.74094 6.22153 6.2885C6.67179 5.83607 7.24551 5.52792 7.87014 5.40302C8.49477 5.27813 9.14225 5.3421 9.73068 5.58686C10.3191 5.83161 10.8221 6.24615 11.1759 6.77804C11.5298 7.30993 11.7187 7.93528 11.7187 8.575C11.7191 8.99993 11.6363 9.42079 11.4747 9.81353C11.3132 10.2063 11.0762 10.5632 10.7773 10.8639C10.4784 11.1646 10.1234 11.4032 9.73267 11.566C9.34192 11.7289 8.92305 11.8128 8.5 11.8129Z",
    fill: "#081754"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.50016,
    cy: 8.4987,
    r: 3.54167,
    fill: "#5CDFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDestinationPin);
export default __webpack_public_path__ + "static/media/destination-pin.b333f848d89801be08488d63969cc44a.svg";
export { ForwardRef as ReactComponent };